import { mergeQueryKeys } from "@lukemorales/query-key-factory";
import { events } from "./event/api/queries";
import { location } from "./location/api/queries";
import { user } from "./users";

export const queries = mergeQueryKeys(events, location, user);
